import { IAuctionServiceCost } from '../../../../../redux/reducers';
import { IAuctionServiceCostSchema } from '../../../../../repositories/billing-tariffs/v1/publish-terms';
import { getServiceId } from '../../../../../utils/publishTerms';

export function mapAuctionServiceCosts(serviceCosts?: IAuctionServiceCostSchema[] | null): IAuctionServiceCost[] {
  if (!serviceCosts) {
    return [];
  }

  return serviceCosts.map(serviceCost => {
    const { serviceTypes, cost } = serviceCost;

    const serviceId = getServiceId(serviceTypes);

    return {
      serviceId,
      serviceTypes,
      cost: Number(cost),
    };
  });
}
